const tags = {
  state: {
    tags: [],//打开的标签
    cache: ['homepage']//（组件名）缓存的组件
  },
  mutations: {
    //添加打开的标签,同步添加缓存
    ADD_TAG(state, view) {
      let exist = false
      for (let tag of state.tags) {
        if((view.name!='Birt' && tag.path == view.path)||(view.name=='Birt' && tag.query && view.query.b==tag.query["b"])){
            tag.fullPath = view.fullPath
            exist = true
        }
      }
      if (!exist) {
        state.tags.push(
          Object.assign({}, view)
        )
      }
      if (state.cache.some(v => v == view.name)) { }
      else {
        state.cache.push(view.name)
      }
    },
    //删除打开的标签,同步删除缓存
    DEL_TAG(state, view) {
      for (const [i, v] of state.tags.entries()) {
        /* if (v.path === view.path) {
          state.tags.splice(i, 1)
          break
        } */
        if((view.name!='Birt' && v.path === view.path)||(view.name=='Birt' && v.query && view.query.b==v.query["b"])){
          state.tags.splice(i, 1)
          break
        }
      }
      for (const [i, v] of state.cache.entries()) {
        if (v == view.name) {
          state.cache.splice(i, 1)
          break
        }
      }
    },
    //删除缓存
    DEL_CACHE(state, name) {
      for (const [i, v] of state.cache.entries()) {
        if (v == name) {
          state.cache.splice(i, 1)
          break
        }
      }
    },
    //删除其他标签
    DEL_OTHER_TAGS(state, view) {
      let temp = [], tempc = []
      for (const [i, v] of state.tags.entries()) {
        if (v.path === view.path || v.name=="Homepage") {
          temp.push(v)
          tempc.push(v.name)
        }
      }
      state.tags = temp
      state.cache = tempc
    },
    //删除所有标签
    DEL_ALL_TAGS(state) {
      state.tags = []
      state.cache = ["homepage"]
    },
    SORT_TAGS(state, tags) {
      state.tags = tags
    }
  },
  actions: {
    addTag({ commit }, view) {
      commit('ADD_TAG', view)
    },
    delTag({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_TAG', view)
        resolve(state.tags)
      })
    },
    delCache({ commit }, name) {
      commit('DEL_CACHE', name)
    },
    delOtherTags({ commit }, view) {
      commit('DEL_OTHER_TAGS', view)
    },
    delAllTags({ commit }) {
      commit('DEL_ALL_TAGS')
    },
    sortTags({ commit }, tags) {
      commit('SORT_TAGS', tags)
    }
  }
}

export default tags
